module.exports = __webpack_public_path__ + "static/media/myob-logo.b675207b.png";